import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CallPage } from './call';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		CallPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(CallPage),
	],
})
export class CallPageModule { }



// WEBPACK FOOTER //
// ./src/pages/call/call.module.ts